import { render, staticRenderFns } from "./BalancesPlanDetailsTable.vue?vue&type=template&id=a74c91f4&"
import script from "./BalancesPlanDetailsTable.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports